import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getTicketDescriptionTextStyles } from 'common/entities/form/styleConfiguration/selectors';
import {
    setTicketDescriptionTextFont,
    setTicketDescriptionTextFontsize,
    setTicketDescriptionTextColor,
} from 'common/entities/form/styleConfiguration/actions';
import { getDefaultStyle, styleShapePropTypes } from 'common/entities/form/styleConfiguration/utils';
import {
    DEFAULT_FONT,
    DEFAULT_SMALL_TICKET_FONT_SIZE,
    DEFAULT_TICKET_DESCRIPTION_COLOR,
} from 'common/entities/form/styleConfiguration/defaultValues';
import DefaultFontTicketStylePanel from './DefaultFontTicketStylePanel';
import { getFormId, getOpenTicketStylingType } from '../../../../selectors';
import { DESCRIPTION_QA } from '../../../../constants/ticketDataQa';
import { DESCRIPTION_LABEL } from '../../../../constants/formStyleLabels';

const FormStyleTicketEditorDescriptionPanel = (props) => (
    <DefaultFontTicketStylePanel
        ticketPanelQaId={DESCRIPTION_QA}
        setTicketPanelFontFamily={props.setTicketDescriptionTextFont}
        setTicketPanelFontSize={props.setTicketDescriptionTextFontsize}
        setTicketPanelTextColor={props.setTicketDescriptionTextColor}
        {...props}
        componentLabel={DESCRIPTION_LABEL}
    />
);

FormStyleTicketEditorDescriptionPanel.propTypes = {
    formId: PropTypes.string.isRequired,
    color: styleShapePropTypes,
    font: styleShapePropTypes,
    fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    setTicketDescriptionTextFont: PropTypes.func.isRequired,
    setTicketDescriptionTextFontsize: PropTypes.func.isRequired,
    setTicketDescriptionTextColor: PropTypes.func.isRequired,
};

FormStyleTicketEditorDescriptionPanel.defaultProps = {
    color: getDefaultStyle(DEFAULT_TICKET_DESCRIPTION_COLOR),
    font: getDefaultStyle(DEFAULT_FONT),
    fontSize: DEFAULT_SMALL_TICKET_FONT_SIZE,
};

const mapStateToProps = (state) => {
    const formId = getFormId(state);
    const openTicketType = getOpenTicketStylingType(state);

    const { color, font, fontSize } = getTicketDescriptionTextStyles(state, formId, openTicketType);

    return {
        formId,
        color,
        font,
        fontSize,
    };
};

const mapDispatchToProps = {
    setTicketDescriptionTextFont,
    setTicketDescriptionTextFontsize,
    setTicketDescriptionTextColor,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormStyleTicketEditorDescriptionPanel);
